"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMemberHeader = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const MemberHeaderStyled = styled_components_1.default.div `
	display: flex;
	justify-content: space-between;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	flex-wrap: wrap;
	gap: 8px;

	.active-bar {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-end;
		flex-shrink: 0;
		position: relative;

	}

	.only-student-checkbox {
		flex-direction: row !important;
		span {
			font-size: 14px;
			padding-bottom: 2px;
		}
	}

	.member {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);

		font-weight: var(--h5-font-weight, 700);
		position: relative;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;

		display: flex;
		align-items: center;
		gap: 20px;
	}

	${props => (props.$isMobile ? mobileStyles : props.$isDesktop ? desktopStyles : tabletStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	flex-direction: column;
	align-items: flex-start;
	width: 100%;

	.search-bar {
		input {
			width: unset;
			font-size: var(--b6-font-size, 10px);
			line-height: var(--b6-line-height, 20px);
			letter-spacing: var(--b6-letter-spacing, -0.02em);
			font-weight: var(--b6-font-weight, 400);
		}
		svg {
			width: 12px;
			height: 12px;
		}
	}

	.member {
		font-size: var(--h5-font-size, 14px);
		line-height: var(--h5-line-height, 24px);
		min-width: 95px;
		flex-direction: row-reverse;
		justify-content: space-between;
		width: 100%;

		p {
			text-align: center !important;
		}
	}

	.active-bar {
		flex-wrap: wrap;
		align-items: flex-start;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	align-items: center;
	gap: 6px;

	.active-bar {
		.search-bar {
			width: 100%;
			&.sm {
				padding: 6px 10px;
			}
			input {
				width: unset;
				font-size: 10px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
			}
		}
	}

	.member {
		font-size: var(--h5-font-size, 14px);
		line-height: 150%;
		min-width: 95px;
		p {
			text-align: center !important;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	flex-direction: row;
	align-items: center;

	.search-bar {
		input {
			width: unset;
			font-size: var(--b6-font-size, 12px);
			line-height: var(--b6-line-height, 20px);
			letter-spacing: var(--b6-letter-spacing, -0.02em);
			font-weight: var(--b6-font-weight, 400);
		}
		svg {
			width: 12px;
			height: 12px;
		}
	}

	.member {
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 24px);
		min-width: 95px;
	}
`;
exports.SendMemberHeader = react_1.default.memo(({ searchOption, handlerFilterList, handlerDelete, isOnlyStudent, setIsOnlyStudent, showOnlyStudentCheckbox = false, totalTableList = 0, isPopup = false, isRegist = false, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [searchContent, setSearchContent] = react_1.default.useState('');
    react_1.default.useEffect(() => {
        setSearchContent(searchOption);
    }, [searchOption]);
    return (react_1.default.createElement(MemberHeaderStyled, { className: "send-member-header", "$isMobile": isMobile, "$isDesktop": isDesktop },
        react_1.default.createElement("div", { className: "member", style: isMobile ?
                { flexDirection: isRegist ? 'row' : 'row-reverse' } : {} },
            !isPopup && isRegist && (react_1.default.createElement(common_1.Button, { text: "common.selectiveDelete", className: `btn_default ${isMobile ? 'mobile-xs' : isTablet ? 'sm' : 'xmd'}`, onClick: handlerDelete, styles: { buttonWrap: { width: isDesktop ? '90px' : '86px', height: isDesktop ? '48px' : isTablet ? '38px' : '32px' } } })),
            (!isMobile || !isPopup) && ((isPopup && isRegist) ? t('sendSMS.everyStudentCount', { count: totalTableList }) : t('conference.receiverCount', { count: totalTableList }))),
        react_1.default.createElement("div", { className: "active-bar", style: { gap: 14 } },
            showOnlyStudentCheckbox && (react_1.default.createElement(common_1.CheckBoxElement, { id: "only_student_member_list", className: "only-student-checkbox", checked: !!isOnlyStudent, title: "sendSMS.onlyStudentSend", handlerCheck: () => setIsOnlyStudent && setIsOnlyStudent(!isOnlyStudent) })),
            react_1.default.createElement(common_1.SearchBar, { className: `${!isMobile ? 'search-bar-qna' : 'search-bar-mobile'}`, filterData: "keyword", handlerFilterList: handlerFilterList, isMember: false, defaultSearchContent: searchContent }))));
});
